



















































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Accounting extends Vue {
	private paginate: string[] = ['paymentHistory'];

	get paymentHistory() {
		// @ts-ignore
		return this.$attrs.policyData.balance.payment_history;
	}
}
